import { API } from '../Auth';

const EP = 'discoverRuns';
const READ_BASE = '/api/v1/schema-library';
const ADMIN_BASE = '/api/admin/schema-library';

// Commercial schema library (platform-api proxy over the profile worker's
// /api/v1/schema-library CRUD). Reads are open to any authenticated user; writes go
// through /api/admin and require the ADMIN role — non-admins get a 403.

// Summary list for the library screen: entries carry tableCount / keyTableCount /
// matchCount instead of the full tables array. NEVER list with includeTables=true —
// post-bundling the full library is thousands of table rows.
export async function listSchemaLibrary({ category, bundled } = {}) {
  const qs = { includeTables: false };
  if (category) qs.category = category;
  if (bundled != null) qs.bundled = bundled;
  return API.get(EP, READ_BASE, { queryStringParameters: qs });
}

// Full entry: metadata + tables[] ({originalTableName, signatureHash, keyTable}).
export async function getSchemaLibraryEntry(id) {
  return API.get(EP, `${READ_BASE}/${encodeURIComponent(id)}`);
}

// Promote an already-profiled database to a library entry. `seedFromSnapshotId` is the
// worker's snapshot UUID (from the data-source metadata summary); `keyTableNames` is
// an optional subset of that snapshot's table names to flag as key tables.
export async function createFromSnapshot({
  vendorName,
  productName,
  productVersion,
  description,
  category,
  defaultSensitivity,
  regulatoryFlags,
  seedFromSnapshotId,
  keyTableNames,
}) {
  return API.post(EP, ADMIN_BASE, {
    body: {
      vendorName,
      productName,
      productVersion: productVersion || null,
      description: description || null,
      category,
      defaultSensitivity,
      regulatoryFlags: regulatoryFlags || [],
      seedFromSnapshotId,
      keyTableNames: keyTableNames && keyTableNames.length > 0 ? keyTableNames : null,
    },
  });
}

// Update a CUSTOM entry (the worker 403s bundled entries). Body shape matches create.
export async function updateSchemaLibraryEntry(id, body) {
  return API.put(EP, `${ADMIN_BASE}/${encodeURIComponent(id)}`, { body });
}

// Soft-delete a CUSTOM entry (worker sets is_active=false; match history survives).
export async function deleteSchemaLibraryEntry(id) {
  return API.del(EP, `${ADMIN_BASE}/${encodeURIComponent(id)}`);
}

// Legal category / sensitivity / flag tokens (V11 column comments — worker-validated).
export const SCHEMA_CATEGORIES = [
  'CRM', 'ERP', 'HRIS', 'ITSM', 'ECOMMERCE', 'HEALTHCARE',
  'FINANCE', 'DEVOPS', 'CMS', 'COLLABORATION', 'CUSTOM',
];
export const SCHEMA_SENSITIVITIES = ['CRITICAL', 'HIGH', 'MEDIUM', 'LOW'];
export const SCHEMA_REGULATORY_FLAGS = ['GDPR', 'CCPA', 'HIPAA', 'HITECH', 'PCI_DSS', 'SOX', 'GLBA'];
